import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.userName), 1),
              _createTextVNode(" user account activated.")
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, { caption: "" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16))
}